import http from '../../../services/api'
import type { APIPaginatedResponse, APIResponse, Filters, Pagination } from '../../../services/types'
import { getRequestParamString } from '../../../services/utils/utils'
import type { UnitApi, UnitInput } from '../types'

const apiPath = import.meta.env.VITE_API_PATH

function resolveUnitUuid(input: Pick<UnitApi, 'uuid'>): string {
  const uuid = input.uuid?.trim()
  if (!uuid) {
    throw new Error('Unit uuid is required')
  }
  return uuid
}

function toUnitPayload(input: UnitInput) {
  return {
    name: input.name.trim(),
    code: input.code.trim(),
    type: input.type,
  }
}

async function getUnits(filters?: Partial<Filters>, pagination?: Partial<Pagination>) {
  const paramString = getRequestParamString(filters, pagination)
  return await http.get<APIPaginatedResponse<UnitApi>>(`${apiPath}units${paramString}`)
}

/** Load the full business catalog for selects (units per business are typically small). */
async function getUnitsForSelect() {
  return await getUnits(undefined, { page: 1, perPage: 200 })
}

async function createUnit(input: UnitInput) {
  return await http.post<APIResponse<UnitApi>>(`${apiPath}units`, toUnitPayload(input))
}

async function updateUnit(input: UnitInput & Pick<UnitApi, 'uuid'>) {
  return await http.put<APIResponse<UnitApi>>(`${apiPath}units/${resolveUnitUuid(input)}`, toUnitPayload(input))
}

async function deactivateUnit(unitUuid: string) {
  return await http.delete<APIResponse<null>>(`${apiPath}units/${resolveUnitUuid({ uuid: unitUuid })}`)
}

const unitsService = {
  getUnits,
  getUnitsForSelect,
  createUnit,
  updateUnit,
  deactivateUnit,
}

export default unitsService
